export default function CrownRounded({
  size,
  color,
  className = "",
  onClick = () => {},
}) {
  return (
    <svg
      onClick={onClick}
      style={{
        width: `${size}px`,
        height: `${size}px`,
        minWidth: `${size}px`,
        minHeight: `${size}px`,
      }}
      fill={color}
      className={className}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm5 17h-10v-2h10v2zm.428-7.096c-.412.19-.428.658-.428 1.085v3.011h-10v-3.011c0-.427-.016-.896-.428-1.085-.34-.157-.572-.506-.572-.904 0-.552.448-1 1-1 .75 0 1.331.843.799 1.597-.268.38-.203.608-.022.875.382.563.936 1.028 1.723 1.028 1.261 0 1.927-1.042 2.065-1.924.048-.307.075-.537-.218-.822-.201-.195-.347-.452-.347-.754 0-.552.448-1 1-1s1 .448 1 1c0 .302-.146.559-.348.754-.293.285-.266.515-.218.822.139.882.805 1.924 2.065 1.924.787 0 1.341-.465 1.724-1.029.181-.266.245-.495-.022-.875-.532-.753.049-1.596.799-1.596.552 0 1 .448 1 1 0 .398-.232.747-.572.904z" />
    </svg>
  );
}
